import type { ReactNode } from 'react';
import s from './BannerMessage.module.css';

interface BannerMessageProps {
  children: ReactNode;
}

const BannerMessage = ({ children }: BannerMessageProps) => {
  return (
    <div className={s.message}>
      <span>{children}</span>
    </div>
  );
};

export { BannerMessage };
